import api from "./api";

const subjectService = {
  getAll: (params) => api.get("/subjects", { params }),

  getSummary: () => api.get("/subjects/summary"),

  getById: (id) => api.get(`/subjects/${id}`),

  create: (data) => api.post("/subjects", data),

  update: (id, data) => api.put(`/subjects/${id}`, data),

  remove: (id) => api.delete(`/subjects/${id}`),
};

export default subjectService;
